// extracted by mini-css-extract-plugin
module.exports = {"image":"lazyImg_image__2nGmb","spinner":"lazyImg_spinner__wfSXh"};